import { render } from "./SwitchHousingCompany.vue?vue&type=template&id=491ca647"
import script from "./SwitchHousingCompany.vue?vue&type=script&lang=js"
export * from "./SwitchHousingCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__